import { router } from "@inertiajs/react";
import { Input } from "~/components/ui/input.jsx";
import { Button } from "~/components/ui/button.jsx";
import { Search } from "lucide-react";
import { useRef } from "react";

export default function () {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const query = params.get("q") || "";

  const serachInputRef = useRef();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      search(e.target.value);
    }
  };

  const handleSearchButtonClick = () => {
    search(serachInputRef.current.value);
  };

  const search = (value) => {
    params.set("q", value);
    params.delete("page");
    router.visit(`?${params.toString()}`);
  };

  return (
    <div className="relative flex space-x-2">
      <Input
        placeholder="Поиск"
        className="w-full py-6"
        onKeyDown={handleKeyDown}
        autofocus
        defaultValue={query}
        ref={serachInputRef}
      />
      <Button size="xl" className="w-40" onClick={handleSearchButtonClick}>
        <Search />
        Найти
      </Button>
    </div>
  );
}
